/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Mailbox_Scan_RunningInputs */

const fr_api_mailbox_scan_running = /** @type {(inputs: Api_Mailbox_Scan_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une relève est déjà en cours. Attendez sa fin.`)
};

const en_api_mailbox_scan_running = /** @type {(inputs: Api_Mailbox_Scan_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A mailbox scan is already running. Wait for it to finish.`)
};

/**
* | output |
* | --- |
* | "A mailbox scan is already running. Wait for it to finish." |
*
* @param {Api_Mailbox_Scan_RunningInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_mailbox_scan_running = /** @type {((inputs?: Api_Mailbox_Scan_RunningInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Mailbox_Scan_RunningInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_mailbox_scan_running(inputs)
	return fr_api_mailbox_scan_running(inputs)
});